import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
    isMobile: false
};

export const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setIsMobile: (state, action: PayloadAction<boolean>) => {
            state.isMobile = action.payload
        },
    },
});

export const { setIsMobile } = dataSlice.actions;
export const data = (state: RootState) => state.data;
export default dataSlice.reducer;